import React from 'react';

const financeCommittee = [
  {
    name: "Prof.  Rupinder Kaur",
    institute: "Punjabi University, Patiala, India"
  },
  {
    name: "Prof.  Chirag Sharma",
    institute: "Lovely Professional University, Punjab, India"
  },
  {
    name: "Prof. Bhawna",
    institute: "SET, CGC University, Mohali"
  },
  {
    name: "Prof. Ishu Sharma",
    institute: "SET, CGC University, Mohali"
  },
  {
    name: "Prof. Tanya Garg",
    institute: "SET, CGC University, Mohali"
  }  
];

const Finance= () => {
  return (
    <div>
      {/* Technical Program Community */}
      <div className='container mx-auto p-4 pt-20 sm:pt-4'>
        <div className="flex flex-wrap w-full relative flex-col flex-auto py-8 px-9">
          <h1 className="mb-2 text-[1.75rem] font-bold text-dark text-center text-4xl uppercase">
          Finance Committee
          </h1>
        </div>
        <div className="flex w-full text-2xl">
          <ul className="list-disc pl-5">
            {financeCommittee .map((member, index) => (
              <li key={index} className="text-lg sm:text-2xl mb-4">
                {member.name}, {member.institute}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Finance;